import React, { useState } from 'react';
import { Checkbox, Collapse, Divider, Table, Typography } from "antd";
import { useTalent } from "../../../providers/TalentProvider";
import ProfileContainer from "../components/ProfileContainer";
import CircleProgress from "../../../components/CircleProgress";
import { useAuth } from "../../../providers/AuthProvider";
import ProfileBrand from "../components/ProfileBrand";
import NEWSkillFormButton from '../components/NEWSkillFormButton';
import AiResumeScoreCallout from '../../talent/AiResumeScoreCallout';

const { Text } = Typography;

const OPTIONS = [
    { title: 'Accomplished', description: '< 6 Years', key: 'wants_junior_experience' },
    { title: 'Advanced', description: '6-10 Years', key: 'wants_intermediate_experience' },
    { title: 'Expert', description: '11+ Years', key: 'wants_senior_experience' },
]
const expColumns = [
    {
        title: 'Meets Criteria?',
        dataIndex: 'meets_criteria',
        key: 'meets_criteria',
        className: 'text-center',
        render: (meets_criteria, _) => (_.match ? (
            <i className={TB.mapClass('fas ', {
                "fa-times text-danger": !meets_criteria,
                "fa-check text-success": meets_criteria,
            })} />
        ) : '-'),
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Experience',
        dataIndex: 'total_experience_label',
        key: 'total_experience_label',
        render: (total_experience_label, record) => (
            <p className="font-semibold">{total_experience_label}</p>
        ),
    },
];
const ExperienceMatchTable = (props) => {

    const { auth } = useAuth();

    const data = useState(() => {
        let disciplines = props.disciplines || [];


    })

}

const MatchCollapseHeader = ({ total, percent, maxTotal, title, type, isActive, disabled, ...props }) => {

    return (
        <div className="py-3 flex justify-start items-center gap-5 pr-3.5">
            <div className="min-w-20 min-h-20 w-20 h-20">
                <CircleProgress
                    progress={disabled ? 0 : percent}
                    strokeWidth={7}>
                    {!disabled ? (
                        <p>
                            <span
                                className="text-base">{Math.round(percent)}%
                            </span>
                            <small className="text-xxs">Match</small>
                        </p>
                    ) : (
                        <p className="text-xxs px-3 opacity-60">No Criteria Set</p>
                    )}
                </CircleProgress>
            </div>

            <p className="text-lg font-bold basis-1/4">
                {title}
            </p>

            {!disabled && (
                !isActive && (
                    <p className="section-subtitle flex-1">
                        Your candidate met the criteria on&nbsp;
                        {(maxTotal > 0 || !props.children) && (
                            <strong>
                                {total} out of {maxTotal} {type}
                            </strong>
                        )}

                        {props.children}
                    </p>
                )
            )}

            <i className={TB.mapClass("ml-auto fa fa-chevron-down transition text-base", { 'rotate-180': isActive })} />
        </div>
    )
}
const TalentProfileMatchScore = () => {
    const { talent, criteria: talentCriteria } = useTalent();
    const { auth } = useAuth();
    const [activeKey, setActiveKey] = useState([]);

    const expOptions = TB.keyBy(OPTIONS, 'key')


    const [metrics] = useState(() => {
        if (!talent) return []

        return talent.matchScoresForCriteria(talentCriteria)
    });

    // console.log('TalentProfileMatchScore', metrics)
    if (!talent.matching) return null;

    // skill expertise
    // industry experience
    // years experience


    const renderImportanceLevelFor = (value, level, section) => {
        return (
            (TB.isDefined(value.matched) || TB.isDefined(value.unmatched)) && (
                <div className="section" key={level + section}>
                    <div className="project-brief-section">
                        <div className="talent-skills">

                            <p className="mb-3 text-base font-semibold">{TB.capitalize(level.replaceAll('_', ' '))}</p>

                            <div className="discipline-skills-container skill-importance-container gap-3">
                                {(value.matched?.length > 0) && value.matched.map((skill) => (
                                    <NEWSkillFormButton
                                        key={`${skill.name}`}
                                        match
                                        readonly
                                        skill={skill}
                                    />
                                ))}
                                {(value.unmatched?.length > 0) && value.unmatched.map((skill) => (
                                    <NEWSkillFormButton
                                        key={`${skill.name}`}
                                        noMatch
                                        readonly
                                        skill={skill}
                                    />
                                )
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            )
        )
    }


    return (
        <div id="match-score" className="pt-2 pb-8">
            <ProfileContainer>
                <div>

                    {/* <h4 className="textbold text-lg pb-6">Match Score</h4> */}

                    <div className="flex justifybetween gap-6 items-center pb-4">
                        <div className="h-[110px] w-[110px]">
                            <CircleProgress
                                progress={metrics.overall_match?.percent}
                                strokeWidth={8}>
                                <p>
                                    <span className="text-2xl">{Math.round(metrics.overall_match?.percent)}%</span>
                                    <small className="text-base">Match</small>
                                </p>
                            </CircleProgress>
                        </div>
                        <div>
                            {/* Staff see three scores on this profile — this
                                one, the AI Resume Score, and the Role Match
                                that blends them. "Overall" claims to be the sum
                                of all three, when it is only the profile half.
                                Clients see this one alone, so for them the
                                broader name is still the accurate one. */}
                            <p className="text-3xl font-bold">
                                {auth?.canManageClients() ? 'Profile Match Score' : 'Overall Match Score'}
                            </p>
                            <p className="text-sm">Based upon criteria we have calculated your overall match score:</p>
                        </div>

                    </div>

                    <Collapse
                        onChange={setActiveKey}
                        activeKey={activeKey}
                    >
                        <Collapse.Panel
                            showArrow={false}
                            // ghost
                            key="skills"
                            header={(
                                <MatchCollapseHeader
                                    isActive={activeKey?.includes('skills')}
                                    percent={metrics.skills_match?.percent}
                                    total={metrics.skills_match?.skills_count}
                                    maxTotal={metrics.skills_match?.skills_max_count}
                                    disabled={metrics.skills_match?.skills_max_count === 0}
                                    type="skills"
                                    title="Skill Expertise" />
                            )}>
                            <div>
                                <div className="section-group">
                                    <div className={TB.mapClass("section match-metric-section flex flex-col items-stretch gap-2", { disabled: metrics.skills_match?.skills_max_count <= 0 })}>

                                        {metrics.skills_match?.skills_max_count > 0 ? (
                                            <p className="section-subtitle">Your candidate met the criteria on&nbsp;
                                                <strong>
                                                    {metrics.skills_match?.skills_count} out of {metrics.skills_match?.skills_max_count} skills:
                                                </strong>
                                            </p>
                                        ) : (
                                            <p className="section-subtitle">
                                                No Criteria Selected
                                            </p>
                                        )}

                                        {metrics.skills_match?.skills_max_count > 0 && (
                                            <p className="section-info text-xxs mb-3">
                                                * Match percentage is determined based upon skills met plus years of experience within the skill
                                            </p>
                                        )}

                                    </div>

                                    {metrics.skills_match?.skills && TB.map(metrics.skills_match.skills, (value, level) =>
                                        renderImportanceLevelFor(value, level, 'skills')
                                    )}

                                </div>
                            </div>
                        </Collapse.Panel>

                        <Collapse.Panel
                            showArrow={false}
                            // ghost
                            key="disciplines"
                            header={(
                                <MatchCollapseHeader
                                    isActive={activeKey?.includes('disciplines')}
                                    percent={metrics.experience_match?.percent}
                                    total={metrics.experience_match?.disciplines_count}
                                    maxTotal={metrics.experience_match?.disciplines_max_count}
                                    disabled={metrics.experience_match?.disciplines_max_count === 0}
                                    type="roles"
                                    title="Role & Experience" />
                            )}>
                            <div>
                                <div className="section-group">
                                    <div
                                        className={TB.mapClass("section match-metric-section flex flex-col items-stretch gap-2", {
                                            // disabled: talent.matching.disciplines?.overall.max_count <= 0
                                        })}>

                                        <p className="section-subtitle">
                                            Criteria selected:
                                        </p>
                                        <div className="flex flex-row items-center justify-start mb-5">

                                            <Checkbox checked={metrics.experience_match?.experience?.junior}
                                                disabled={!metrics.experience_match?.experience?.junior} readOnly
                                                className={TB.mapClass(" flex-1 pointer-events-none", {
                                                    'font-semibold': metrics.experience_match?.experience?.junior
                                                })}>
                                                {expOptions['wants_junior_experience']?.title}&nbsp;
                                                {expOptions['wants_junior_experience']?.description}
                                            </Checkbox>
                                            <Checkbox checked={metrics.experience_match?.experience?.intermediate}
                                                disabled={!metrics.experience_match?.experience?.intermediate} readOnly
                                                className={TB.mapClass(" flex-1 pointer-events-none", {
                                                    'font-semibold': metrics.experience_match?.experience?.intermediate
                                                })}>
                                                {expOptions['wants_intermediate_experience']?.title}&nbsp;
                                                {expOptions['wants_intermediate_experience']?.description}
                                            </Checkbox>
                                            <Checkbox checked={metrics.experience_match?.experience?.senior}
                                                disabled={!metrics.experience_match?.experience?.senior} readOnly
                                                className={TB.mapClass(" flex-1 pointer-events-none", {
                                                    'font-semibold': metrics.experience_match?.experience?.senior
                                                })}>
                                                {expOptions['wants_senior_experience']?.title}&nbsp;
                                                {expOptions['wants_senior_experience']?.description}
                                            </Checkbox>
                                        </div>
                                        <Table
                                            size="small"
                                            rowKey="id"
                                            pagination={false} columns={expColumns}
                                            dataSource={metrics.experience_match?.disciplines || []} />
                                    </div>


                                </div>
                            </div>
                        </Collapse.Panel>
                        <Collapse.Panel
                            showArrow={false}
                            // ghost
                            key="industries"
                            header={(
                                <MatchCollapseHeader
                                    isActive={activeKey?.includes('industries')}
                                    percent={metrics.industries_brands_match.percent}
                                    disabled={metrics.industries_brands_match.total_max_count === 0}
                                    total={metrics.industries_brands_match.industries_count}
                                    maxTotal={metrics.industries_brands_match.industries_max_count} type="industries"
                                    title={metrics.industries_brands_match.brands_max_count > 0 ? 'Industry/Brand Expertise' : 'Industry Expertise'}>
                                    {metrics.industries_brands_match.brands_max_count > 0 && (
                                        <React.Fragment>
                                            {metrics.industries_brands_match.industries_max_count > 0 ? (<span>&nbsp;and&nbsp;</span>) : ''}
                                            <strong>
                                                {metrics.industries_brands_match.brands_count} out of {metrics.industries_brands_match.brands_max_count} brands
                                            </strong>

                                        </React.Fragment>
                                    )}
                                </MatchCollapseHeader>
                            )}>
                            <div>
                                <div className="section-group">
                                    <div className={TB.mapClass("section match-metric-section flex flex-col items-stretch gap-2", { disabled: (metrics.industries_brands_match?.industries_max_count + metrics.industries_brands_match?.brands_max_count) <= 0 })}>

                                        {metrics.industries_brands_match.industries_max_count > 0 ? (
                                            <p className="section-subtitle">
                                                Your candidate met the criteria on&nbsp;
                                                <strong>
                                                    {metrics.industries_brands_match.industries_count} out of {metrics.industries_brands_match.industries_max_count} industries
                                                </strong>
                                            </p>
                                        ) : (
                                            <p className="section-subtitle">
                                                No Industry/Brand Criteria Selected
                                            </p>
                                        )}

                                        {metrics.industries_brands_match.industries_max_count > 0 && (
                                            <p className="section-info text-xxs mb-3">
                                                * Match percentage is determined based upon total years of experience within each industry selected {metrics.industries_brands_match.brands_max_count > 0 && 'and matching brands.'}
                                            </p>
                                        )}

                                    </div>

                                    {metrics.industries_brands_match?.industries && TB.map(metrics.industries_brands_match?.industries, (value, level) =>
                                        renderImportanceLevelFor(value, level, 'industries')
                                    )}

                                    <React.Fragment>
                                        <Divider className="mt-1.5" />
                                        <div className="flex flex-col items-stretch gap-2">
                                            {metrics.industries_brands_match?.brands_max_count > 0 ? (
                                                <p className="section-subtitle">
                                                    Your candidate met the criteria on&nbsp;
                                                    <strong>
                                                        {metrics.industries_brands_match?.brands_count} out of {metrics.industries_brands_match?.brands_max_count} brands
                                                    </strong>

                                                </p>
                                            ) : (
                                                <p className="section-subtitle">
                                                    No Brand Criteria Selected
                                                </p>
                                            )}
                                            {(metrics.industries_brands_match?.brands || [])?.length > 0 && (
                                                <div className="flex flex-row flex-wrap items-center gap-6">
                                                    {TB.map(metrics.industries_brands_match?.brands || [], (brand) => (
                                                        <ProfileBrand key={brand.id} brand={brand} isDisabled={!brand.match}
                                                            tooltipPlacement="bottom">
                                                            {brand.match && (
                                                                <div className="absolute top-2 right-2">
                                                                    <div
                                                                        className="flex items-center justify-center bg-white h-3 w-3 rounded-full">
                                                                        <i className="fas fa-check-circle text-success text-sm" />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </ProfileBrand>
                                                    ))}
                                                </div>
                                            )}

                                        </div>
                                    </React.Fragment>

                                </div>
                            </div>
                        </Collapse.Panel>


                    </Collapse>

                    {/* Below the criteria panels and ruled off from them: those
                        three are what the Match Score is made of, this is a
                        separate AI read that sits outside the calculation. */}
                    {/*{TB.isDefined(talent.resumeMatchScore?.()) && (*/}
                    {/*    <div className="mt-6 border-t border-[#E2E3EA] pt-6">*/}
                    {/*        <AiResumeScoreCallout score={talent.resumeMatchScore()} />*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>
            </ProfileContainer>
        </div>
    )
}

export default TalentProfileMatchScore;